@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../constants/spacing.module.less';

.page-content {
  padding: 0 24px 24px;
  height: 100%;

  h1 {
    padding: 24px @space-0 @space-0;
    margin: @space-0;
    white-space: nowrap;
  }
}

.sub-title-container {
  width: 100%;
  padding-bottom: @space-8;

  .helper-link {
    font-size: 14px;
    margin-left: @space-0;
    line-height: 18px;
  }
}

.header-bar {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 24px;
  border-bottom: 1px solid @insights-page--header--border-color;
}

.analytics-page-content {
  padding: 0 @space-24 @space-24;
  height: 100%;
  background-color: var(--gray-F9FAFB);
  overflow: auto;

  .analytics-page-header {
    margin: @space-0;
    white-space: nowrap;
    padding: @space-24 @space-0;
  }
}
